import React, { FC } from 'react';
import { Div, Span, P } from '@kizi/core-components';
import { PercentageBar } from '@kizi/comparator-components';
import { IProduct } from '@kizi/comparator-core';

interface SpeedPopupProps {
  data: IProduct;
}

export const SpeedPopup: FC<SpeedPopupProps> = ({ data }) => {
  const advertisedDownloadSpeed =
    data.servicesWrapper?.networkInformation?.internetSpeed?.downloadSpeedInMb;
  const advertisedUploadSpeed =
    data.servicesWrapper?.networkInformation?.internetSpeed?.uploadSpeedInMb;

  if (!advertisedDownloadSpeed || !advertisedUploadSpeed) {
    return null;
  }

  const generateBottomLabel = () => {
    switch (data.servicesWrapper?.networkInformation?.network?.signal) {
      case 'vdsl':
      case 'adsl':
        return 'De werkelijke snelheid van VDSL-internet is afhankelijk van de afstand tot uw wijkcentrale en de kwaliteit van de lijn. Ook is het gebruik van een draadloos Wifi-netwerk en de kwaliteit van bekabeling binnenshuis van invloed op de uiteindelijke snelheid.';
      case 'glasvezel':
        return 'Bij glasvezelinternet is de up- en downloadsnelheid hetzelfde. Wel is het gebruik van een draadloos wifi-netwerk en de kwaliteit van bekabeling binnenshuis van invloed op de uiteindelijke snelheid.';
      case 'kabel':
        return 'Met kabelinternet is de downloadsnelheid vaak hoger dan de uploadsnelheid. Het gebruik van een draadloos Wifi-netwerk en de kwaliteit van bekabeling binnenshuis is van invloed op de uiteindelijke snelheid.';
      default:
        return '';
    }
  };

  return (
    <Div my={'20px'}>
      <P variant="bodyV2">Te verwachten snelheid</P>
      <Div variant="internetSpeedPopup">
        <P variant="regularV2">Downloadsnelheid</P>
        <P variant="regularV2">
          <Span>{`${advertisedDownloadSpeed} Mb/s van ${advertisedDownloadSpeed} Mb/s`}</Span>
        </P>
      </Div>
      <PercentageBar innerWidth={100} />
      <Div variant="internetSpeedPopup">
        <P variant="regularV2">Uploadsnelheid</P>
        <P variant="regularV2">
          <Span>{`${advertisedUploadSpeed} Mb/s van ${advertisedUploadSpeed} Mb/s`}</Span>
        </P>
      </Div>
      <PercentageBar innerWidth={100} />
      <P variant="regularV2">{generateBottomLabel()}</P>
    </Div>
  );
};
